// extracted by mini-css-extract-plugin
module.exports = {"cursor":"css_cursor__1dVJD","full":"css_full__3jsha"};